import { createMuiTheme } from '@material-ui/core/styles';

const lightTheme = (colors: any) =>
	createMuiTheme({
		palette: {
			primary: {
				main: colors.primary,
			},
			secondary: {
				main: colors.secondary,
			},
			success: {
				main: colors.positive,
			},
			warning: {
				main: colors.negative,
			},
			text: {
				primary: '#263238',
			},
			background: {
				default: '#F5F6F8',
			},
		},
		overrides: {
			MuiTypography: {
				h5: {
					fontWeight: 500,
				},
				h6: {
					fontSize: '1rem',
				},
			},
		},
	});

const darkTheme = (colors: any) =>
	createMuiTheme({
		palette: {
			type: 'dark',
			primary: {
				main: colors.primary,
			},
			secondary: {
				main: colors.secondary,
			},
			success: {
				main: colors.positive,
			},
			warning: {
				main: colors.negative,
			},
		},
		overrides: {
			MuiTypography: {
				h5: {
					fontWeight: 500,
				},
				h6: {
					fontSize: '1rem',
				},
			},
		},
	});

export { lightTheme, darkTheme };
